export default __webpack_public_path__ + "static/media/079-ticket office.a099b23e.svg";